import axios from "axios";

const CommonBaseUrl = process.env.REACT_APP_BASE_URL;

const baseUrl = `${CommonBaseUrl}/Admin`;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
}

export const createPost = async (title, body, source, type, language) => {
  try {
    // Retrieve the token from cookie using the helper function
    const token = getCookie("token");
    const response = await axios.post(
      `${baseUrl}/createpost`,
      { title, body, source, type, language },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating post: ", error);
    throw error;
  }
};

export const createResource = async (title, body, source, type) => {
  try {
    // Retrieve the token from cookie using the helper function
    const token = getCookie("token");
    const response = await axios.post(
      `${baseUrl}/createresource`,
      { title, body, source, type },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating post: ", error);
    throw error;
  }
};

export const editpost = async (
  postId,
  title,
  body,
  source,
  type,
  language,
  is_posted
) => {
  const token = getCookie("token");
  try {
    const response = await axios.post(
      `${baseUrl}/editpost`,
      {
        postId,
        title,
        body,
        source,
        type,
        language,
        is_posted,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    return response.data;
  } catch (error) {
    console.error("Error editing post: ", error);
    throw error;
  }
};

export const editResource = async (postId, title, body, source, is_posted) => {
  const token = getCookie("token");
  try {
    const response = await axios.post(
      `${baseUrl}/editresource`,
      {
        postId,
        title,
        body,
        source,
        is_posted,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error("Error editing post: ", error);
    throw error;
  }
};

export const getAllPost = async (is_posted, type, page = 1) => {
  const token = getCookie("token");
  try {
    const response = await axios.post(
      `${baseUrl}/fetchAllPost`,
      {
        is_posted,
        type,
        page, // Add page parameter for pagination
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching post: ", error);
    throw error;
  }
};

export const fetchPostsAndResources = async ({
  type = "",
  startDate,
  endDate,
  page = 1,
  pageSize = 15,
} = {}) => {
  const token = getCookie("token");

  try {
    const response = await axios.post(
      `${baseUrl}/listPostsAndResources`,
      {
        type, // e.g., "post:news", "resource", or empty string
        startDate, // optional
        endDate, // optional
        page,
        pageSize,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching posts and resources:", error);
    throw error;
  }
};

export const getAllResource = async (is_posted, page = 1) => {
  const token = getCookie("token");
  try {
    const response = await axios.post(
      `${baseUrl}/fetchallresource`,
      {
        is_posted,
        page, // Add page parameter for pagination
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching post: ", error);
    throw error;
  }
};

// export async function fetchViewsPerPeriod(params = {}) {
//   try {
//     const response = await axios.post(`${baseUrl}/fetchViewsPerPeriod`, params);
//     console.log('Response from fetchViewsPerPeriod:', response.data);

//     return response.data; // { period: "day" | "week" | "month", data: [...] }
//   } catch (error) {
//     console.error("Failed to fetch view stats:", error);
//     throw error;
//   }
// }
export const fetchViewsPerPeriod = async (params = {}) => {
  try {
    const response = await axios.post(`${baseUrl}/fetchViewsPerPeriod`, params);
    console.log("baseUrl:", baseUrl);
    console.log("Response from fetchViewsPerPeriod:", response.data);
    return response.data; // { period: "day" | "week" | "month", data: [...] }
  } catch (error) {
    console.error("Failed to fetch view stats:", error);
    throw error;
  }
};
export const uploadFile = async (file, folder, onProgress) => {
  try {
    const formData = new FormData();
    formData.append("file", file); // The file to upload
    formData.append("key", folder); // Folder name expected by backend

    const response = await axios.post(
      `${CommonBaseUrl}/Fileupload/upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          if (!onProgress) return;
          const total = progressEvent.total || 0;
          if (total <= 0) return;
          const progress = Math.round((progressEvent.loaded * 100) / total);
          onProgress(progress);
        },
      }
    );

    // Assuming backend returns: { filelink, message }
    return response.data;
  } catch (error) {
    console.error("Error uploading file: ", error);
    throw error;
  }
};

export const sendToGroup = async (postIds, message, topicId) => {
  try {
    const token = getCookie("token");
    const response = await axios.post(
      `${baseUrl}/sendposttogroup`,
      {
        postIds,
        message,
        topicId,
        token,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error("Error sending posts to group: ", error);
    throw error;
  }
};

export const sendToGroupResoruce = async (resourceIds, message, topicId) => {
  try {
    const token = getCookie("token");
    const response = await axios.post(
      `${baseUrl}/sendresource`,
      {
        resourceIds: resourceIds,
        message,
        topicId,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error("Error sending posts to group: ", error);
    throw error;
  }
};

export const deletePost = async (postId) => {
  const token = getCookie("token");

  try {
    const response = await axios.post(
      `${baseUrl}/deletepost`,
      { postId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting post: ", error);
    throw error;
  }
};

export const deleteResource = async (postId) => {
  const token = getCookie("token");

  try {
    const response = await axios.post(
      `${baseUrl}/deleteresource`,
      { postId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting post: ", error);
    throw error;
  }
};
